const abi$9 = [{
  inputs: [{
    internalType: 'bytes32',
    type: 'bytes32'
  }],
  name: 'getAlternativeSignature',
  outputs: [{
    internalType: 'string',
    type: 'string'
  }],
  stateMutability: 'view',
  type: 'function'
}];

var erc5719 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  abi: abi$9
});

const abi$8 = [{
  type: 'function',
  name: 'isValidSignature',
  constant: true,
  inputs: [{
    type: 'bytes32'
  }, {
    type: 'bytes'
  }],
  outputs: [{
    type: 'bytes4'
  }],
  payable: false,
  stateMutability: 'view'
}];
const returns = {
  isValidSignatureBytes32: '0x1626ba7e'
};

var erc1271 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  abi: abi$8,
  returns: returns
});

const abi$7 = [{
  inputs: [{
    internalType: 'bytes',
    name: 'error',
    type: 'bytes'
  }],
  name: 'ERC1271Revert',
  type: 'error'
}, {
  inputs: [{
    internalType: 'bytes',
    name: 'error',
    type: 'bytes'
  }],
  name: 'ERC6492DeployFailed',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: '_signer',
    type: 'address'
  }, {
    internalType: 'bytes32',
    name: '_hash',
    type: 'bytes32'
  }, {
    internalType: 'bytes',
    name: '_signature',
    type: 'bytes'
  }],
  name: 'isValidSig',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '_signer',
    type: 'address'
  }, {
    internalType: 'bytes32',
    name: '_hash',
    type: 'bytes32'
  }, {
    internalType: 'bytes',
    name: '_signature',
    type: 'bytes'
  }, {
    internalType: 'bool',
    name: 'allowSideEffects',
    type: 'bool'
  }, {
    internalType: 'bool',
    name: 'deployAlreadyDeployed',
    type: 'bool'
  }],
  name: 'isValidSigImpl',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '_signer',
    type: 'address'
  }, {
    internalType: 'bytes32',
    name: '_hash',
    type: 'bytes32'
  }, {
    internalType: 'bytes',
    name: '_signature',
    type: 'bytes'
  }],
  name: 'isValidSigNoThrow',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '_signer',
    type: 'address'
  }, {
    internalType: 'bytes32',
    name: '_hash',
    type: 'bytes32'
  }, {
    internalType: 'bytes',
    name: '_signature',
    type: 'bytes'
  }],
  name: 'isValidSigWithSideEffects',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '_signer',
    type: 'address'
  }, {
    internalType: 'bytes32',
    name: '_hash',
    type: 'bytes32'
  }, {
    internalType: 'bytes',
    name: '_signature',
    type: 'bytes'
  }],
  name: 'isValidSigWithSideEffectsNoThrow',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}];

var erc6492 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  abi: abi$7
});

const abi$6 = [{
  type: 'function',
  name: 'deploy',
  constant: false,
  inputs: [{
    type: 'address'
  }, {
    type: 'bytes32'
  }],
  outputs: [],
  payable: true,
  stateMutability: 'payable'
}];

var factory = /*#__PURE__*/Object.freeze({
  __proto__: null,
  abi: abi$6
});

const abi$5 = [{
  type: 'function',
  name: 'nonce',
  constant: true,
  inputs: [],
  outputs: [{
    type: 'uint256'
  }],
  payable: false,
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'readNonce',
  constant: true,
  inputs: [{
    type: 'uint256'
  }],
  outputs: [{
    type: 'uint256'
  }],
  payable: false,
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'updateImplementation',
  constant: false,
  inputs: [{
    type: 'address'
  }],
  outputs: [],
  payable: false,
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'selfExecute',
  constant: false,
  inputs: [{
    components: [{
      type: 'bool',
      name: 'delegateCall'
    }, {
      type: 'bool',
      name: 'revertOnError'
    }, {
      type: 'uint256',
      name: 'gasLimit'
    }, {
      type: 'address',
      name: 'target'
    }, {
      type: 'uint256',
      name: 'value'
    }, {
      type: 'bytes',
      name: 'data'
    }],
    type: 'tuple[]'
  }],
  outputs: [],
  payable: false,
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'execute',
  constant: false,
  inputs: [{
    components: [{
      type: 'bool',
      name: 'delegateCall'
    }, {
      type: 'bool',
      name: 'revertOnError'
    }, {
      type: 'uint256',
      name: 'gasLimit'
    }, {
      type: 'address',
      name: 'target'
    }, {
      type: 'uint256',
      name: 'value'
    }, {
      type: 'bytes',
      name: 'data'
    }],
    type: 'tuple[]'
  }, {
    type: 'uint256'
  }, {
    type: 'bytes'
  }],
  outputs: [],
  payable: false,
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'createContract',
  inputs: [{
    type: 'bytes'
  }],
  payable: true,
  stateMutability: 'payable'
}, {
  type: 'function',
  name: 'setExtraImageHash',
  constant: false,
  inputs: [{
    type: 'bytes32',
    name: 'imageHash'
  }, {
    type: 'uint256',
    name: 'expiration'
  }],
  outputs: [],
  payable: false,
  stateMutability: 'nonpayable'
}];

var mainModule = /*#__PURE__*/Object.freeze({
  __proto__: null,
  abi: abi$5
});

const abi$4 = [{
  type: 'function',
  name: 'updateImageHash',
  constant: true,
  inputs: [{
    type: 'bytes32'
  }],
  outputs: [],
  payable: false,
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'imageHash',
  constant: true,
  inputs: [],
  outputs: [{
    type: 'bytes32'
  }],
  payable: false,
  stateMutability: 'view'
}];

var mainModuleUpgradable = /*#__PURE__*/Object.freeze({
  __proto__: null,
  abi: abi$4
});

const abi$3 = [{
  inputs: [{
    internalType: 'bytes4',
    name: '_signature',
    type: 'bytes4'
  }],
  name: 'HookAlreadyExists',
  type: 'error'
}, {
  inputs: [{
    internalType: 'bytes4',
    name: '_signature',
    type: 'bytes4'
  }],
  name: 'HookDoesNotExist',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: '_sender',
    type: 'address'
  }, {
    internalType: 'address',
    name: '_self',
    type: 'address'
  }],
  name: 'OnlySelfAuth',
  type: 'error'
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: 'bytes4',
    name: '_signature',
    type: 'bytes4'
  }, {
    indexed: false,
    internalType: 'address',
    name: '_implementation',
    type: 'address'
  }],
  name: 'DefinedHook',
  type: 'event'
}, {
  stateMutability: 'payable',
  type: 'fallback'
}, {
  inputs: [{
    internalType: 'bytes4',
    name: '_signature',
    type: 'bytes4'
  }, {
    internalType: 'address',
    name: '_implementation',
    type: 'address'
  }],
  name: 'addHook',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }, {
    internalType: 'address',
    name: '',
    type: 'address'
  }, {
    internalType: 'uint256[]',
    name: '',
    type: 'uint256[]'
  }, {
    internalType: 'uint256[]',
    name: '',
    type: 'uint256[]'
  }, {
    internalType: 'bytes',
    name: '',
    type: 'bytes'
  }],
  name: 'onERC1155BatchReceived',
  outputs: [{
    internalType: 'bytes4',
    name: '',
    type: 'bytes4'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }, {
    internalType: 'address',
    name: '',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: '',
    type: 'bytes'
  }],
  name: 'onERC1155Received',
  outputs: [{
    internalType: 'bytes4',
    name: '',
    type: 'bytes4'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }, {
    internalType: 'address',
    name: '',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: '',
    type: 'bytes'
  }],
  name: 'onERC721Received',
  outputs: [{
    internalType: 'bytes4',
    name: '',
    type: 'bytes4'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes4',
    name: '_signature',
    type: 'bytes4'
  }],
  name: 'readHook',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes4',
    name: '_signature',
    type: 'bytes4'
  }],
  name: 'removeHook',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes4',
    name: '_interfaceID',
    type: 'bytes4'
  }],
  name: 'supportsInterface',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'pure',
  type: 'function'
}, {
  stateMutability: 'payable',
  type: 'receive'
}];

var moduleHooks = /*#__PURE__*/Object.freeze({
  __proto__: null,
  abi: abi$3
});

const abi$2 = [{
  inputs: [{
    internalType: 'address',
    name: '_factory',
    type: 'address'
  }, {
    internalType: 'address',
    name: '_mainModule',
    type: 'address'
  }],
  stateMutability: 'nonpayable',
  type: 'constructor'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: '_wallet',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'bytes32',
    name: '_imageHash',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: '_threshold',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'bytes',
    name: '_signers',
    type: 'bytes'
  }],
  name: 'RequiredConfig',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: '_wallet',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: '_signer',
    type: 'address'
  }],
  name: 'RequiredSigner',
  type: 'event'
}, {
  inputs: [{
    internalType: 'address',
    name: '_addr',
    type: 'address'
  }],
  name: 'callBalanceOf',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'callBlockNumber',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '_i',
    type: 'uint256'
  }],
  name: 'callBlockhash',
  outputs: [{
    internalType: 'bytes32',
    name: '',
    type: 'bytes32'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'callChainId',
  outputs: [{
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }],
  stateMutability: 'pure',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '_addr',
    type: 'address'
  }],
  name: 'callCode',
  outputs: [{
    internalType: 'bytes',
    name: 'code',
    type: 'bytes'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '_addr',
    type: 'address'
  }],
  name: 'callCodeHash',
  outputs: [{
    internalType: 'bytes32',
    name: 'codeHash',
    type: 'bytes32'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '_addr',
    type: 'address'
  }],
  name: 'callCodeSize',
  outputs: [{
    internalType: 'uint256',
    name: 'size',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'callCoinbase',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'callDifficulty',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'callGasLeft',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'callGasLimit',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'callGasPrice',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'callOrigin',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'callTimestamp',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  name: 'knownImageHashes',
  outputs: [{
    internalType: 'bytes32',
    name: '',
    type: 'bytes32'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: '',
    type: 'bytes32'
  }],
  name: 'lastImageHashUpdate',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  name: 'lastSignerUpdate',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  name: 'lastWalletUpdate',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    components: [{
      internalType: 'bool',
      name: 'delegateCall',
      type: 'bool'
    }, {
      internalType: 'bool',
      name: 'revertOnError',
      type: 'bool'
    }, {
      internalType: 'uint256',
      name: 'gasLimit',
      type: 'uint256'
    }, {
      internalType: 'address',
      name: 'target',
      type: 'address'
    }, {
      internalType: 'uint256',
      name: 'value',
      type: 'uint256'
    }, {
      internalType: 'bytes',
      name: 'data',
      type: 'bytes'
    }],
    internalType: 'struct IModuleCalls.Transaction[]',
    name: '_txs',
    type: 'tuple[]'
  }],
  name: 'multiCall',
  outputs: [{
    internalType: 'bool[]',
    name: '_successes',
    type: 'bool[]'
  }, {
    internalType: 'bytes[]',
    name: '_results',
    type: 'bytes[]'
  }],
  stateMutability: 'payable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '_wallet',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: '_threshold',
    type: 'uint256'
  }, {
    components: [{
      internalType: 'uint256',
      name: 'weight',
      type: 'uint256'
    }, {
      internalType: 'address',
      name: 'signer',
      type: 'address'
    }],
    internalType: 'struct RequireUtils.Member[]',
    name: '_members',
    type: 'tuple[]'
  }, {
    internalType: 'bool',
    name: '_index',
    type: 'bool'
  }],
  name: 'publishConfig',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '_wallet',
    type: 'address'
  }, {
    internalType: 'bytes32',
    name: '_hash',
    type: 'bytes32'
  }, {
    internalType: 'uint256',
    name: '_sizeMembers',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: '_signature',
    type: 'bytes'
  }, {
    internalType: 'bool',
    name: '_index',
    type: 'bool'
  }],
  name: 'publishInitialSigners',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: '_wallet',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: '_nonce',
    type: 'uint256'
  }],
  name: 'requireMinNonce',
  outputs: [],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '_expiration',
    type: 'uint256'
  }],
  name: 'requireNonExpired',
  outputs: [],
  stateMutability: 'view',
  type: 'function'
}];

var sequenceUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  abi: abi$2
});

const abi$1 = [{
  inputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  name: 'requireFreshSigner',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}];

var requireFreshSigner = /*#__PURE__*/Object.freeze({
  __proto__: null,
  abi: abi$1
});

const abi = [{
  type: 'function',
  name: 'PROXY_getImplementation',
  inputs: [],
  outputs: [{
    name: '',
    type: 'address',
    internalType: 'address'
  }],
  stateMutability: 'view'
}];

var walletProxyHook = /*#__PURE__*/Object.freeze({
  __proto__: null,
  abi: abi
});

/**
 * @deprecated import directly from @0xsequence/abi/* instead, omitting "walletContracts"
 */
const walletContracts = {
  erc6492,
  erc5719,
  erc1271,
  factory,
  mainModule,
  mainModuleUpgradable,
  moduleHooks,
  sequenceUtils,
  requireFreshSigner,
  walletProxyHook
};

// @openzeppelin/contracts@5.0.0/token/ERC1155/ERC1155.sol
const ERC1155_ABI = [{
  inputs: [],
  stateMutability: 'nonpayable',
  type: 'constructor'
}, {
  inputs: [{
    internalType: 'address',
    name: 'sender',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'balance',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'needed',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }],
  name: 'ERC1155InsufficientBalance',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'approver',
    type: 'address'
  }],
  name: 'ERC1155InvalidApprover',
  type: 'error'
}, {
  inputs: [{
    internalType: 'uint256',
    name: 'idsLength',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'valuesLength',
    type: 'uint256'
  }],
  name: 'ERC1155InvalidArrayLength',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }],
  name: 'ERC1155InvalidOperator',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'receiver',
    type: 'address'
  }],
  name: 'ERC1155InvalidReceiver',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'sender',
    type: 'address'
  }],
  name: 'ERC1155InvalidSender',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }],
  name: 'ERC1155MissingApprovalForAll',
  type: 'error'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'account',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'bool',
    name: 'approved',
    type: 'bool'
  }],
  name: 'ApprovalForAll',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'from',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'to',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'uint256[]',
    name: 'ids',
    type: 'uint256[]'
  }, {
    indexed: false,
    internalType: 'uint256[]',
    name: 'values',
    type: 'uint256[]'
  }],
  name: 'TransferBatch',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'from',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'to',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'value',
    type: 'uint256'
  }],
  name: 'TransferSingle',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: 'string',
    name: 'value',
    type: 'string'
  }, {
    indexed: true,
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }],
  name: 'URI',
  type: 'event'
}, {
  inputs: [{
    internalType: 'address',
    name: 'account',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }],
  name: 'balanceOf',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address[]',
    name: 'accounts',
    type: 'address[]'
  }, {
    internalType: 'uint256[]',
    name: 'ids',
    type: 'uint256[]'
  }],
  name: 'balanceOfBatch',
  outputs: [{
    internalType: 'uint256[]',
    name: '',
    type: 'uint256[]'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'account',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }],
  name: 'isApprovedForAll',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'from',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'to',
    type: 'address'
  }, {
    internalType: 'uint256[]',
    name: 'ids',
    type: 'uint256[]'
  }, {
    internalType: 'uint256[]',
    name: 'values',
    type: 'uint256[]'
  }, {
    internalType: 'bytes',
    name: 'data',
    type: 'bytes'
  }],
  name: 'safeBatchTransferFrom',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'from',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'to',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'value',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: 'data',
    type: 'bytes'
  }],
  name: 'safeTransferFrom',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }, {
    internalType: 'bool',
    name: 'approved',
    type: 'bool'
  }],
  name: 'setApprovalForAll',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes4',
    name: 'interfaceId',
    type: 'bytes4'
  }],
  name: 'supportsInterface',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  name: 'uri',
  outputs: [{
    internalType: 'string',
    name: '',
    type: 'string'
  }],
  stateMutability: 'view',
  type: 'function'
}];

// @openzeppelin/contracts@5.0.0/token/ERC20/ERC20.sol
const ERC20_ABI = [{
  inputs: [],
  stateMutability: 'nonpayable',
  type: 'constructor'
}, {
  inputs: [{
    internalType: 'address',
    name: 'spender',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'allowance',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'needed',
    type: 'uint256'
  }],
  name: 'ERC20InsufficientAllowance',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'sender',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'balance',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'needed',
    type: 'uint256'
  }],
  name: 'ERC20InsufficientBalance',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'approver',
    type: 'address'
  }],
  name: 'ERC20InvalidApprover',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'receiver',
    type: 'address'
  }],
  name: 'ERC20InvalidReceiver',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'sender',
    type: 'address'
  }],
  name: 'ERC20InvalidSender',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'spender',
    type: 'address'
  }],
  name: 'ERC20InvalidSpender',
  type: 'error'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'spender',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'value',
    type: 'uint256'
  }],
  name: 'Approval',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'from',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'to',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'value',
    type: 'uint256'
  }],
  name: 'Transfer',
  type: 'event'
}, {
  inputs: [{
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'spender',
    type: 'address'
  }],
  name: 'allowance',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'spender',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'value',
    type: 'uint256'
  }],
  name: 'approve',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'account',
    type: 'address'
  }],
  name: 'balanceOf',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'decimals',
  outputs: [{
    internalType: 'uint8',
    name: '',
    type: 'uint8'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'name',
  outputs: [{
    internalType: 'string',
    name: '',
    type: 'string'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'symbol',
  outputs: [{
    internalType: 'string',
    name: '',
    type: 'string'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'totalSupply',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'to',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'value',
    type: 'uint256'
  }],
  name: 'transfer',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'from',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'to',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'value',
    type: 'uint256'
  }],
  name: 'transferFrom',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}];

// @openzeppelin/contracts@5.0.0/token/ERC6909/ERC6909.sol
const ERC6909_ABI = [{
  inputs: [{
    internalType: 'address',
    name: 'spender',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'allowance',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'needed',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }],
  name: 'ERC6909InsufficientAllowance',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'sender',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'balance',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'needed',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }],
  name: 'ERC6909InsufficientBalance',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'approver',
    type: 'address'
  }],
  name: 'ERC6909InvalidApprover',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'receiver',
    type: 'address'
  }],
  name: 'ERC6909InvalidReceiver',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'sender',
    type: 'address'
  }],
  name: 'ERC6909InvalidSender',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'spender',
    type: 'address'
  }],
  name: 'ERC6909InvalidSpender',
  type: 'error'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'spender',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'amount',
    type: 'uint256'
  }],
  name: 'Approval',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'spender',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'bool',
    name: 'approved',
    type: 'bool'
  }],
  name: 'OperatorSet',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: 'address',
    name: 'caller',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'sender',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'receiver',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'amount',
    type: 'uint256'
  }],
  name: 'Transfer',
  type: 'event'
}, {
  inputs: [{
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'spender',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }],
  name: 'allowance',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'spender',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'amount',
    type: 'uint256'
  }],
  name: 'approve',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }],
  name: 'balanceOf',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'spender',
    type: 'address'
  }],
  name: 'isOperator',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'spender',
    type: 'address'
  }, {
    internalType: 'bool',
    name: 'approved',
    type: 'bool'
  }],
  name: 'setOperator',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes4',
    name: 'interfaceId',
    type: 'bytes4'
  }],
  name: 'supportsInterface',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'receiver',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'amount',
    type: 'uint256'
  }],
  name: 'transfer',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'sender',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'receiver',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'id',
    type: 'uint256'
  }, {
    internalType: 'uint256',
    name: 'amount',
    type: 'uint256'
  }],
  name: 'transferFrom',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}];

// @openzeppelin/contracts@5.0.0/token/ERC721/ERC721.sol
const ERC721_ABI = [{
  inputs: [],
  stateMutability: 'nonpayable',
  type: 'constructor'
}, {
  inputs: [{
    internalType: 'address',
    name: 'sender',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }, {
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }],
  name: 'ERC721IncorrectOwner',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }],
  name: 'ERC721InsufficientApproval',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'approver',
    type: 'address'
  }],
  name: 'ERC721InvalidApprover',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }],
  name: 'ERC721InvalidOperator',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }],
  name: 'ERC721InvalidOwner',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'receiver',
    type: 'address'
  }],
  name: 'ERC721InvalidReceiver',
  type: 'error'
}, {
  inputs: [{
    internalType: 'address',
    name: 'sender',
    type: 'address'
  }],
  name: 'ERC721InvalidSender',
  type: 'error'
}, {
  inputs: [{
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }],
  name: 'ERC721NonexistentToken',
  type: 'error'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'approved',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }],
  name: 'Approval',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'bool',
    name: 'approved',
    type: 'bool'
  }],
  name: 'ApprovalForAll',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'from',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'to',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }],
  name: 'Transfer',
  type: 'event'
}, {
  inputs: [{
    internalType: 'address',
    name: 'to',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }],
  name: 'approve',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }],
  name: 'balanceOf',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }],
  name: 'getApproved',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }],
  name: 'isApprovedForAll',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'name',
  outputs: [{
    internalType: 'string',
    name: '',
    type: 'string'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }],
  name: 'ownerOf',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'from',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'to',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }],
  name: 'safeTransferFrom',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'from',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'to',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: 'data',
    type: 'bytes'
  }],
  name: 'safeTransferFrom',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }, {
    internalType: 'bool',
    name: 'approved',
    type: 'bool'
  }],
  name: 'setApprovalForAll',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes4',
    name: 'interfaceId',
    type: 'bytes4'
  }],
  name: 'supportsInterface',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'symbol',
  outputs: [{
    internalType: 'string',
    name: '',
    type: 'string'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }],
  name: 'tokenURI',
  outputs: [{
    internalType: 'string',
    name: '',
    type: 'string'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'from',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'to',
    type: 'address'
  }, {
    internalType: 'uint256',
    name: 'tokenId',
    type: 'uint256'
  }],
  name: 'transferFrom',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}];

const ERC1155_SALE_ABI = [{
  type: 'function',
  name: 'DEFAULT_ADMIN_ROLE',
  inputs: [],
  outputs: [{
    name: '',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'checkMerkleProof',
  inputs: [{
    name: 'root',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'proof',
    type: 'bytes32[]',
    internalType: 'bytes32[]'
  }, {
    name: 'addr',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'salt',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  outputs: [{
    name: '',
    type: 'bool',
    internalType: 'bool'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'getRoleAdmin',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  outputs: [{
    name: '',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'getRoleMember',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'index',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [{
    name: '',
    type: 'address',
    internalType: 'address'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'getRoleMemberCount',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  outputs: [{
    name: '',
    type: 'uint256',
    internalType: 'uint256'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'grantRole',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'hasRole',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [{
    name: '',
    type: 'bool',
    internalType: 'bool'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'initialize',
  inputs: [{
    name: 'owner',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'items',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'itemsContract',
  inputs: [],
  outputs: [{
    name: '',
    type: 'address',
    internalType: 'address'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'mint',
  inputs: [{
    name: 'to',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'amount',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'paymentToken',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'maxTotal',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'proof',
    type: 'bytes32[]',
    internalType: 'bytes32[]'
  }],
  outputs: [],
  stateMutability: 'payable'
}, {
  type: 'function',
  name: 'renounceRole',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'revokeRole',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'saleDetails',
  inputs: [],
  outputs: [{
    name: '',
    type: 'tuple',
    internalType: 'struct IERC721SaleFunctions.SaleDetails',
    components: [{
      name: 'supplyCap',
      type: 'uint256',
      internalType: 'uint256'
    }, {
      name: 'cost',
      type: 'uint256',
      internalType: 'uint256'
    }, {
      name: 'paymentToken',
      type: 'address',
      internalType: 'address'
    }, {
      name: 'startTime',
      type: 'uint64',
      internalType: 'uint64'
    }, {
      name: 'endTime',
      type: 'uint64',
      internalType: 'uint64'
    }, {
      name: 'merkleRoot',
      type: 'bytes32',
      internalType: 'bytes32'
    }]
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'setSaleDetails',
  inputs: [{
    name: 'supplyCap',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'cost',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'paymentToken',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'startTime',
    type: 'uint64',
    internalType: 'uint64'
  }, {
    name: 'endTime',
    type: 'uint64',
    internalType: 'uint64'
  }, {
    name: 'merkleRoot',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'supportsInterface',
  inputs: [{
    name: 'interfaceId',
    type: 'bytes4',
    internalType: 'bytes4'
  }],
  outputs: [{
    name: '',
    type: 'bool',
    internalType: 'bool'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'withdrawERC20',
  inputs: [{
    name: 'token',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'to',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'value',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'withdrawETH',
  inputs: [{
    name: 'to',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'value',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'event',
  name: 'RoleAdminChanged',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }, {
    name: 'previousAdminRole',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }, {
    name: 'newAdminRole',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }],
  anonymous: false
}, {
  type: 'event',
  name: 'RoleGranted',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: 'sender',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }],
  anonymous: false
}, {
  type: 'event',
  name: 'RoleRevoked',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: 'sender',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }],
  anonymous: false
}, {
  type: 'event',
  name: 'SaleDetailsUpdated',
  inputs: [{
    name: 'supplyCap',
    type: 'uint256',
    indexed: false,
    internalType: 'uint256'
  }, {
    name: 'cost',
    type: 'uint256',
    indexed: false,
    internalType: 'uint256'
  }, {
    name: 'paymentToken',
    type: 'address',
    indexed: false,
    internalType: 'address'
  }, {
    name: 'startTime',
    type: 'uint64',
    indexed: false,
    internalType: 'uint64'
  }, {
    name: 'endTime',
    type: 'uint64',
    indexed: false,
    internalType: 'uint64'
  }, {
    name: 'merkleRoot',
    type: 'bytes32',
    indexed: false,
    internalType: 'bytes32'
  }],
  anonymous: false
}, {
  type: 'error',
  name: 'InsufficientPayment',
  inputs: [{
    name: 'currency',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'expected',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'actual',
    type: 'uint256',
    internalType: 'uint256'
  }]
}, {
  type: 'error',
  name: 'InsufficientSupply',
  inputs: [{
    name: 'currentSupply',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'amount',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'maxSupply',
    type: 'uint256',
    internalType: 'uint256'
  }]
}, {
  type: 'error',
  name: 'InvalidInitialization',
  inputs: []
}, {
  type: 'error',
  name: 'InvalidSaleDetails',
  inputs: []
}, {
  type: 'error',
  name: 'MerkleProofInvalid',
  inputs: [{
    name: 'root',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'proof',
    type: 'bytes32[]',
    internalType: 'bytes32[]'
  }, {
    name: 'addr',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'salt',
    type: 'bytes32',
    internalType: 'bytes32'
  }]
}, {
  type: 'error',
  name: 'SaleInactive',
  inputs: []
}, {
  type: 'error',
  name: 'WithdrawFailed',
  inputs: []
}];

const ERC721_SALE_ABI = [{
  type: 'function',
  name: 'DEFAULT_ADMIN_ROLE',
  inputs: [],
  outputs: [{
    name: '',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'checkMerkleProof',
  inputs: [{
    name: 'root',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'proof',
    type: 'bytes32[]',
    internalType: 'bytes32[]'
  }, {
    name: 'addr',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'salt',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  outputs: [{
    name: '',
    type: 'bool',
    internalType: 'bool'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'getRoleAdmin',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  outputs: [{
    name: '',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'getRoleMember',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'index',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [{
    name: '',
    type: 'address',
    internalType: 'address'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'getRoleMemberCount',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  outputs: [{
    name: '',
    type: 'uint256',
    internalType: 'uint256'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'grantRole',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'hasRole',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [{
    name: '',
    type: 'bool',
    internalType: 'bool'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'initialize',
  inputs: [{
    name: 'owner',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'items',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'itemsContract',
  inputs: [],
  outputs: [{
    name: '',
    type: 'address',
    internalType: 'address'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'mint',
  inputs: [{
    name: 'to',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'amount',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'paymentToken',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'maxTotal',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'proof',
    type: 'bytes32[]',
    internalType: 'bytes32[]'
  }],
  outputs: [],
  stateMutability: 'payable'
}, {
  type: 'function',
  name: 'renounceRole',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'revokeRole',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'saleDetails',
  inputs: [],
  outputs: [{
    name: '',
    type: 'tuple',
    internalType: 'struct IERC721SaleFunctions.SaleDetails',
    components: [{
      name: 'supplyCap',
      type: 'uint256',
      internalType: 'uint256'
    }, {
      name: 'cost',
      type: 'uint256',
      internalType: 'uint256'
    }, {
      name: 'paymentToken',
      type: 'address',
      internalType: 'address'
    }, {
      name: 'startTime',
      type: 'uint64',
      internalType: 'uint64'
    }, {
      name: 'endTime',
      type: 'uint64',
      internalType: 'uint64'
    }, {
      name: 'merkleRoot',
      type: 'bytes32',
      internalType: 'bytes32'
    }]
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'setSaleDetails',
  inputs: [{
    name: 'supplyCap',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'cost',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'paymentToken',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'startTime',
    type: 'uint64',
    internalType: 'uint64'
  }, {
    name: 'endTime',
    type: 'uint64',
    internalType: 'uint64'
  }, {
    name: 'merkleRoot',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'supportsInterface',
  inputs: [{
    name: 'interfaceId',
    type: 'bytes4',
    internalType: 'bytes4'
  }],
  outputs: [{
    name: '',
    type: 'bool',
    internalType: 'bool'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'withdrawERC20',
  inputs: [{
    name: 'token',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'to',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'value',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'withdrawETH',
  inputs: [{
    name: 'to',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'value',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'event',
  name: 'RoleAdminChanged',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }, {
    name: 'previousAdminRole',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }, {
    name: 'newAdminRole',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }],
  anonymous: false
}, {
  type: 'event',
  name: 'RoleGranted',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: 'sender',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }],
  anonymous: false
}, {
  type: 'event',
  name: 'RoleRevoked',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: 'sender',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }],
  anonymous: false
}, {
  type: 'event',
  name: 'SaleDetailsUpdated',
  inputs: [{
    name: 'supplyCap',
    type: 'uint256',
    indexed: false,
    internalType: 'uint256'
  }, {
    name: 'cost',
    type: 'uint256',
    indexed: false,
    internalType: 'uint256'
  }, {
    name: 'paymentToken',
    type: 'address',
    indexed: false,
    internalType: 'address'
  }, {
    name: 'startTime',
    type: 'uint64',
    indexed: false,
    internalType: 'uint64'
  }, {
    name: 'endTime',
    type: 'uint64',
    indexed: false,
    internalType: 'uint64'
  }, {
    name: 'merkleRoot',
    type: 'bytes32',
    indexed: false,
    internalType: 'bytes32'
  }],
  anonymous: false
}, {
  type: 'error',
  name: 'InsufficientPayment',
  inputs: [{
    name: 'currency',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'expected',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'actual',
    type: 'uint256',
    internalType: 'uint256'
  }]
}, {
  type: 'error',
  name: 'InsufficientSupply',
  inputs: [{
    name: 'currentSupply',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'amount',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'maxSupply',
    type: 'uint256',
    internalType: 'uint256'
  }]
}, {
  type: 'error',
  name: 'InvalidInitialization',
  inputs: []
}, {
  type: 'error',
  name: 'InvalidSaleDetails',
  inputs: []
}, {
  type: 'error',
  name: 'MerkleProofInvalid',
  inputs: [{
    name: 'root',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'proof',
    type: 'bytes32[]',
    internalType: 'bytes32[]'
  }, {
    name: 'addr',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'salt',
    type: 'bytes32',
    internalType: 'bytes32'
  }]
}, {
  type: 'error',
  name: 'SaleInactive',
  inputs: []
}, {
  type: 'error',
  name: 'WithdrawFailed',
  inputs: []
}];

const ERC1155_SALE_ITEMS_ABI = [{
  type: 'constructor',
  inputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'DEFAULT_ADMIN_ROLE',
  inputs: [],
  outputs: [{
    name: '',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'balanceOf',
  inputs: [{
    name: '_owner',
    type: 'address',
    internalType: 'address'
  }, {
    name: '_id',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [{
    name: '',
    type: 'uint256',
    internalType: 'uint256'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'balanceOfBatch',
  inputs: [{
    name: '_owners',
    type: 'address[]',
    internalType: 'address[]'
  }, {
    name: '_ids',
    type: 'uint256[]',
    internalType: 'uint256[]'
  }],
  outputs: [{
    name: '',
    type: 'uint256[]',
    internalType: 'uint256[]'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'baseURI',
  inputs: [],
  outputs: [{
    name: '',
    type: 'string',
    internalType: 'string'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'batchBurn',
  inputs: [{
    name: 'tokenIds',
    type: 'uint256[]',
    internalType: 'uint256[]'
  }, {
    name: 'amounts',
    type: 'uint256[]',
    internalType: 'uint256[]'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'batchMint',
  inputs: [{
    name: 'to',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'tokenIds',
    type: 'uint256[]',
    internalType: 'uint256[]'
  }, {
    name: 'amounts',
    type: 'uint256[]',
    internalType: 'uint256[]'
  }, {
    name: 'data',
    type: 'bytes',
    internalType: 'bytes'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'burn',
  inputs: [{
    name: 'tokenId',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'amount',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'contractURI',
  inputs: [],
  outputs: [{
    name: '',
    type: 'string',
    internalType: 'string'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'getRoleAdmin',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  outputs: [{
    name: '',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'getRoleMember',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'index',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [{
    name: '',
    type: 'address',
    internalType: 'address'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'getRoleMemberCount',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  outputs: [{
    name: '',
    type: 'uint256',
    internalType: 'uint256'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'grantRole',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'hasRole',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [{
    name: '',
    type: 'bool',
    internalType: 'bool'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'initialize',
  inputs: [{
    name: 'owner',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'tokenName',
    type: 'string',
    internalType: 'string'
  }, {
    name: 'tokenBaseURI',
    type: 'string',
    internalType: 'string'
  }, {
    name: 'tokenContractURI',
    type: 'string',
    internalType: 'string'
  }, {
    name: 'royaltyReceiver',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'royaltyFeeNumerator',
    type: 'uint96',
    internalType: 'uint96'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'isApprovedForAll',
  inputs: [{
    name: '_owner',
    type: 'address',
    internalType: 'address'
  }, {
    name: '_operator',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [{
    name: 'isOperator',
    type: 'bool',
    internalType: 'bool'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'mint',
  inputs: [{
    name: 'to',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'tokenId',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'amount',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'data',
    type: 'bytes',
    internalType: 'bytes'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'name',
  inputs: [],
  outputs: [{
    name: '',
    type: 'string',
    internalType: 'string'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'renounceRole',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'revokeRole',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'royaltyInfo',
  inputs: [{
    name: 'tokenId',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'salePrice',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [{
    name: '',
    type: 'address',
    internalType: 'address'
  }, {
    name: '',
    type: 'uint256',
    internalType: 'uint256'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'safeBatchTransferFrom',
  inputs: [{
    name: '_from',
    type: 'address',
    internalType: 'address'
  }, {
    name: '_to',
    type: 'address',
    internalType: 'address'
  }, {
    name: '_ids',
    type: 'uint256[]',
    internalType: 'uint256[]'
  }, {
    name: '_amounts',
    type: 'uint256[]',
    internalType: 'uint256[]'
  }, {
    name: '_data',
    type: 'bytes',
    internalType: 'bytes'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'safeTransferFrom',
  inputs: [{
    name: '_from',
    type: 'address',
    internalType: 'address'
  }, {
    name: '_to',
    type: 'address',
    internalType: 'address'
  }, {
    name: '_id',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: '_amount',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: '_data',
    type: 'bytes',
    internalType: 'bytes'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'setApprovalForAll',
  inputs: [{
    name: '_operator',
    type: 'address',
    internalType: 'address'
  }, {
    name: '_approved',
    type: 'bool',
    internalType: 'bool'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'setBaseMetadataURI',
  inputs: [{
    name: 'tokenBaseURI',
    type: 'string',
    internalType: 'string'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'setContractName',
  inputs: [{
    name: 'tokenName',
    type: 'string',
    internalType: 'string'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'setContractURI',
  inputs: [{
    name: 'tokenContractURI',
    type: 'string',
    internalType: 'string'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'setDefaultRoyalty',
  inputs: [{
    name: 'receiver',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'feeNumerator',
    type: 'uint96',
    internalType: 'uint96'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'setTokenRoyalty',
  inputs: [{
    name: 'tokenId',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'receiver',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'feeNumerator',
    type: 'uint96',
    internalType: 'uint96'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'supportsInterface',
  inputs: [{
    name: 'interfaceId',
    type: 'bytes4',
    internalType: 'bytes4'
  }],
  outputs: [{
    name: '',
    type: 'bool',
    internalType: 'bool'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'tokenSupply',
  inputs: [{
    name: '',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [{
    name: '',
    type: 'uint256',
    internalType: 'uint256'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'totalSupply',
  inputs: [],
  outputs: [{
    name: '',
    type: 'uint256',
    internalType: 'uint256'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'uri',
  inputs: [{
    name: '_id',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [{
    name: '',
    type: 'string',
    internalType: 'string'
  }],
  stateMutability: 'view'
}, {
  type: 'event',
  name: 'ApprovalForAll',
  inputs: [{
    name: '_owner',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: '_operator',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: '_approved',
    type: 'bool',
    indexed: false,
    internalType: 'bool'
  }],
  anonymous: false
}, {
  type: 'event',
  name: 'RoleAdminChanged',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }, {
    name: 'previousAdminRole',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }, {
    name: 'newAdminRole',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }],
  anonymous: false
}, {
  type: 'event',
  name: 'RoleGranted',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: 'sender',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }],
  anonymous: false
}, {
  type: 'event',
  name: 'RoleRevoked',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: 'sender',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }],
  anonymous: false
}, {
  type: 'event',
  name: 'TransferBatch',
  inputs: [{
    name: '_operator',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: '_from',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: '_to',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: '_ids',
    type: 'uint256[]',
    indexed: false,
    internalType: 'uint256[]'
  }, {
    name: '_amounts',
    type: 'uint256[]',
    indexed: false,
    internalType: 'uint256[]'
  }],
  anonymous: false
}, {
  type: 'event',
  name: 'TransferSingle',
  inputs: [{
    name: '_operator',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: '_from',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: '_to',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: '_id',
    type: 'uint256',
    indexed: false,
    internalType: 'uint256'
  }, {
    name: '_amount',
    type: 'uint256',
    indexed: false,
    internalType: 'uint256'
  }],
  anonymous: false
}, {
  type: 'event',
  name: 'URI',
  inputs: [{
    name: '_uri',
    type: 'string',
    indexed: false,
    internalType: 'string'
  }, {
    name: '_id',
    type: 'uint256',
    indexed: true,
    internalType: 'uint256'
  }],
  anonymous: false
}, {
  type: 'error',
  name: 'InvalidArrayLength',
  inputs: []
}, {
  type: 'error',
  name: 'InvalidInitialization',
  inputs: []
}];

const ERC721_SALE_ITEMS_ABI = [{
  type: 'constructor',
  inputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'DEFAULT_ADMIN_ROLE',
  inputs: [],
  outputs: [{
    name: '',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'approve',
  inputs: [{
    name: 'to',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'tokenId',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [],
  stateMutability: 'payable'
}, {
  type: 'function',
  name: 'balanceOf',
  inputs: [{
    name: 'owner',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [{
    name: '',
    type: 'uint256',
    internalType: 'uint256'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'batchBurn',
  inputs: [{
    name: 'tokenIds',
    type: 'uint256[]',
    internalType: 'uint256[]'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'burn',
  inputs: [{
    name: 'tokenId',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'contractURI',
  inputs: [],
  outputs: [{
    name: '',
    type: 'string',
    internalType: 'string'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'explicitOwnershipOf',
  inputs: [{
    name: 'tokenId',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [{
    name: '',
    type: 'tuple',
    internalType: 'struct IERC721A.TokenOwnership',
    components: [{
      name: 'addr',
      type: 'address',
      internalType: 'address'
    }, {
      name: 'startTimestamp',
      type: 'uint64',
      internalType: 'uint64'
    }, {
      name: 'burned',
      type: 'bool',
      internalType: 'bool'
    }, {
      name: 'extraData',
      type: 'uint24',
      internalType: 'uint24'
    }]
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'explicitOwnershipsOf',
  inputs: [{
    name: 'tokenIds',
    type: 'uint256[]',
    internalType: 'uint256[]'
  }],
  outputs: [{
    name: '',
    type: 'tuple[]',
    internalType: 'struct IERC721A.TokenOwnership[]',
    components: [{
      name: 'addr',
      type: 'address',
      internalType: 'address'
    }, {
      name: 'startTimestamp',
      type: 'uint64',
      internalType: 'uint64'
    }, {
      name: 'burned',
      type: 'bool',
      internalType: 'bool'
    }, {
      name: 'extraData',
      type: 'uint24',
      internalType: 'uint24'
    }]
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'getApproved',
  inputs: [{
    name: 'tokenId',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [{
    name: '',
    type: 'address',
    internalType: 'address'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'getRoleAdmin',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  outputs: [{
    name: '',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'getRoleMember',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'index',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [{
    name: '',
    type: 'address',
    internalType: 'address'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'getRoleMemberCount',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }],
  outputs: [{
    name: '',
    type: 'uint256',
    internalType: 'uint256'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'grantRole',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'hasRole',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [{
    name: '',
    type: 'bool',
    internalType: 'bool'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'initialize',
  inputs: [{
    name: 'owner',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'tokenName',
    type: 'string',
    internalType: 'string'
  }, {
    name: 'tokenSymbol',
    type: 'string',
    internalType: 'string'
  }, {
    name: 'tokenBaseURI',
    type: 'string',
    internalType: 'string'
  }, {
    name: 'tokenContractURI',
    type: 'string',
    internalType: 'string'
  }, {
    name: 'royaltyReceiver',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'royaltyFeeNumerator',
    type: 'uint96',
    internalType: 'uint96'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'isApprovedForAll',
  inputs: [{
    name: 'owner',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'operator',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [{
    name: '',
    type: 'bool',
    internalType: 'bool'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'mint',
  inputs: [{
    name: 'to',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'amount',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'name',
  inputs: [],
  outputs: [{
    name: '',
    type: 'string',
    internalType: 'string'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'ownerOf',
  inputs: [{
    name: 'tokenId',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [{
    name: '',
    type: 'address',
    internalType: 'address'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'renounceRole',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'revokeRole',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'royaltyInfo',
  inputs: [{
    name: 'tokenId',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'salePrice',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [{
    name: '',
    type: 'address',
    internalType: 'address'
  }, {
    name: '',
    type: 'uint256',
    internalType: 'uint256'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'safeTransferFrom',
  inputs: [{
    name: 'from',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'to',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'tokenId',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [],
  stateMutability: 'payable'
}, {
  type: 'function',
  name: 'safeTransferFrom',
  inputs: [{
    name: 'from',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'to',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'tokenId',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: '_data',
    type: 'bytes',
    internalType: 'bytes'
  }],
  outputs: [],
  stateMutability: 'payable'
}, {
  type: 'function',
  name: 'setApprovalForAll',
  inputs: [{
    name: 'operator',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'approved',
    type: 'bool',
    internalType: 'bool'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'setBaseMetadataURI',
  inputs: [{
    name: 'tokenBaseURI',
    type: 'string',
    internalType: 'string'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'setContractURI',
  inputs: [{
    name: 'tokenContractURI',
    type: 'string',
    internalType: 'string'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'setDefaultRoyalty',
  inputs: [{
    name: 'receiver',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'feeNumerator',
    type: 'uint96',
    internalType: 'uint96'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'setNameAndSymbol',
  inputs: [{
    name: 'tokenName',
    type: 'string',
    internalType: 'string'
  }, {
    name: 'tokenSymbol',
    type: 'string',
    internalType: 'string'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'setTokenRoyalty',
  inputs: [{
    name: 'tokenId',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'receiver',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'feeNumerator',
    type: 'uint96',
    internalType: 'uint96'
  }],
  outputs: [],
  stateMutability: 'nonpayable'
}, {
  type: 'function',
  name: 'supportsInterface',
  inputs: [{
    name: 'interfaceId',
    type: 'bytes4',
    internalType: 'bytes4'
  }],
  outputs: [{
    name: '',
    type: 'bool',
    internalType: 'bool'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'symbol',
  inputs: [],
  outputs: [{
    name: '',
    type: 'string',
    internalType: 'string'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'tokenURI',
  inputs: [{
    name: 'tokenId',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [{
    name: '',
    type: 'string',
    internalType: 'string'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'tokensOfOwner',
  inputs: [{
    name: 'owner',
    type: 'address',
    internalType: 'address'
  }],
  outputs: [{
    name: '',
    type: 'uint256[]',
    internalType: 'uint256[]'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'tokensOfOwnerIn',
  inputs: [{
    name: 'owner',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'start',
    type: 'uint256',
    internalType: 'uint256'
  }, {
    name: 'stop',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [{
    name: '',
    type: 'uint256[]',
    internalType: 'uint256[]'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'totalSupply',
  inputs: [],
  outputs: [{
    name: '',
    type: 'uint256',
    internalType: 'uint256'
  }],
  stateMutability: 'view'
}, {
  type: 'function',
  name: 'transferFrom',
  inputs: [{
    name: 'from',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'to',
    type: 'address',
    internalType: 'address'
  }, {
    name: 'tokenId',
    type: 'uint256',
    internalType: 'uint256'
  }],
  outputs: [],
  stateMutability: 'payable'
}, {
  type: 'event',
  name: 'Approval',
  inputs: [{
    name: 'owner',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: 'approved',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: 'tokenId',
    type: 'uint256',
    indexed: true,
    internalType: 'uint256'
  }],
  anonymous: false
}, {
  type: 'event',
  name: 'ApprovalForAll',
  inputs: [{
    name: 'owner',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: 'operator',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: 'approved',
    type: 'bool',
    indexed: false,
    internalType: 'bool'
  }],
  anonymous: false
}, {
  type: 'event',
  name: 'ConsecutiveTransfer',
  inputs: [{
    name: 'fromTokenId',
    type: 'uint256',
    indexed: true,
    internalType: 'uint256'
  }, {
    name: 'toTokenId',
    type: 'uint256',
    indexed: false,
    internalType: 'uint256'
  }, {
    name: 'from',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: 'to',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }],
  anonymous: false
}, {
  type: 'event',
  name: 'RoleAdminChanged',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }, {
    name: 'previousAdminRole',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }, {
    name: 'newAdminRole',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }],
  anonymous: false
}, {
  type: 'event',
  name: 'RoleGranted',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: 'sender',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }],
  anonymous: false
}, {
  type: 'event',
  name: 'RoleRevoked',
  inputs: [{
    name: 'role',
    type: 'bytes32',
    indexed: true,
    internalType: 'bytes32'
  }, {
    name: 'account',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: 'sender',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }],
  anonymous: false
}, {
  type: 'event',
  name: 'Transfer',
  inputs: [{
    name: 'from',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: 'to',
    type: 'address',
    indexed: true,
    internalType: 'address'
  }, {
    name: 'tokenId',
    type: 'uint256',
    indexed: true,
    internalType: 'uint256'
  }],
  anonymous: false
}, {
  type: 'error',
  name: 'ApprovalCallerNotOwnerNorApproved',
  inputs: []
}, {
  type: 'error',
  name: 'ApprovalQueryForNonexistentToken',
  inputs: []
}, {
  type: 'error',
  name: 'BalanceQueryForZeroAddress',
  inputs: []
}, {
  type: 'error',
  name: 'InvalidInitialization',
  inputs: []
}, {
  type: 'error',
  name: 'InvalidQueryRange',
  inputs: []
}, {
  type: 'error',
  name: 'MintERC2309QuantityExceedsLimit',
  inputs: []
}, {
  type: 'error',
  name: 'MintToZeroAddress',
  inputs: []
}, {
  type: 'error',
  name: 'MintZeroQuantity',
  inputs: []
}, {
  type: 'error',
  name: 'OwnerQueryForNonexistentToken',
  inputs: []
}, {
  type: 'error',
  name: 'OwnershipNotInitializedForExtraData',
  inputs: []
}, {
  type: 'error',
  name: 'TransferCallerNotOwnerNorApproved',
  inputs: []
}, {
  type: 'error',
  name: 'TransferFromIncorrectOwner',
  inputs: []
}, {
  type: 'error',
  name: 'TransferToNonERC721ReceiverImplementer',
  inputs: []
}, {
  type: 'error',
  name: 'TransferToZeroAddress',
  inputs: []
}, {
  type: 'error',
  name: 'URIQueryForNonexistentToken',
  inputs: []
}];

export { ERC1155_ABI, ERC1155_SALE_ABI, ERC1155_SALE_ITEMS_ABI, ERC20_ABI, ERC6909_ABI, ERC721_ABI, ERC721_SALE_ABI, ERC721_SALE_ITEMS_ABI, abi$8 as erc1271Abi, abi$9 as erc5719Abi, abi$7 as erc6492Abi, abi$6 as factoryAbi, abi$5 as mainModuleAbi, abi$4 as mainModuleUpgradableAbi, abi$3 as moduleHooksAbi, abi$1 as requireFreshSignerAbi, abi$2 as sequenceUtilsAbi, walletContracts, abi as walletProxyHookAbi };
